import { forwardRef } from "react";
import * as DropdownMenuPrimitive from "@radix-ui/react-dropdown-menu";

import type {
  TDropdownMenuLabelElement,
  TDropdownMenuLabelProps,
} from "@/ui/components/overlay/DropdownMenu/DropdownMenu.config";
import { cn } from "@/ui/lib/utils";
import { TextControl } from "../../typography/TextControl";

export const DropdownMenuLabel = forwardRef<TDropdownMenuLabelElement, TDropdownMenuLabelProps>(
  (
    {
      children,
      className,
      inset,
      ...props
    },
    ref,
  ) => (
    <DropdownMenuPrimitive.Label
      data-component="DropdownMenuLabel"
      ref={ref}
      className={cn(
        "px-2",
        inset && "pl-8",
        className,
      )}
      {...props}
    >
      <TextControl tag="span" size={2} isResponsive={false}>
        { children }
      </TextControl>
    </DropdownMenuPrimitive.Label>
  ),
);

DropdownMenuLabel.displayName = DropdownMenuPrimitive.Label.displayName;
